import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../_db";
import { useLanguage } from "@/contexts/LanguageContext";

interface DischargeTypesDoc {
  types: {
    en: string[];
    pt: string[];
  };
}

export const useDischargeTypes = () => {
  const [dischargeTypes, setDischargeTypes] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { language } = useLanguage();

  useEffect(() => {
    const fetchDischargeTypes = async () => {
      try {
        setLoading(true);
        setError(null);

        const docRef = doc(db, "settings", "water_discharge");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data() as DischargeTypesDoc;
          const types = data.types?.[language as keyof typeof data.types] || [];
          setDischargeTypes(types);
        } else {
          console.warn("Discharge types document not found");
          setDischargeTypes([]);
        }
      } catch (err) {
        console.error("Error fetching discharge types:", err);
        setError("Failed to fetch discharge types");
        setDischargeTypes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDischargeTypes();
  }, [language]);

  return { dischargeTypes, loading, error };
};
